<template>
    <div style="padding: 15px;background-color: #fff">
        <div class="content" >
            <div>
<!--                <li>动态路由传参query{{$route.query}}</li>-->
                <li class="findInfo font-17" >{{$route.query.key || ' '}}</li>
            </div>
            <div class="text-left flex font-14 padding-top flex justify-between">
                <li>搜索{{$route.query.key}}</li>
                <li>共计<span class="text-red">{{searchMax}}</span>个搜索结果</li>
            </div>
            <div>
                <!--        全景数据-->
                <vr-item style="margin-top: 15px;padding-bottom: 15px" :vrInfo="vr_info"></vr-item>
            </div>
            <div v-if="searchMax===0" >
                <nullPage style="padding: 150px 0;"></nullPage>
            </div>
            <!--        分页-->
            <el-pagination class="phone-pagination" style="padding-top:20px;padding-bottom: 40px"
                           background @current-change="current_change"
                           :page-size="1"
                           layout="prev, pager, next, jumper"
                           :total="maxPage">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import vrItem from '@/components/vr-item-class'
    import nullPage from "@/components/nullPage";
    export default {
        name: "searchInfo",
        components: {
            vrItem,nullPage
        },
        data(){
            const vrItem={
                vrimg:'http://browser9.qhimg.com/bdm/480_296_0/t01cd97ec806b712059.jpg',
                title:'望谟县大观镇伏开村全景图',
                id:'GYNJS234234',
                address:'贵州省黔西南州望谟县大关乡上伏开村一组',
                see:'255',praise:'254'
            }
            return{
                // vr_info:Array(25).fill(vrItem),
                vr_info:[],
                searchMax:0,
                searchValue:'',
                maxPage:0, // 分页
                DataStatus:true, // 下滑是否有数据请求完
            }
        },
        created() {
            this.Searchs(this.$route.query.key,1)
            this.keyword = this.$route.query.key
        },
        methods:{
            Searchs(value,e){

                console.log(value)
                this.$http({
                    url:this.$Api.search,
                    params:{
                        keyword:value,
                        page:e,
                        pageSize:25
                    }
                }).then((res)=>{
                    console.log('搜索结果',res)
                    this.searchMax = res.data.length
                    this.maxPage = res.count
                    this.vr_info = res.data
                })
            },
            // 分页
            current_change(e){
                console.log('分页',e)
                this.Searchs(this.keyword,e) // 全部列表
            },
            // 监听浏览器滚动事件
            main() {
                console.log('main')
                //addEventListener适用于版本较新的IE浏览器 ，如IE9以及火狐浏览器，
                document.addEventListener("mousewheel", this.MouseWheelHandler, false);
                // Firefox浏览器使用的滚轮事件是 DOMMouseScroll
                document.addEventListener("DOMMouseScroll", this.MouseWheelHandler, false);
                document.addEventListener('scroll', this.MouseWheelHandler, true);
            },
            // 获得滚动的值
            MouseWheelHandler() {
                let scrollTop = 0;
                if (document.documentElement && document.documentElement.scrollTop) {
                    scrollTop = document.documentElement.scrollTop;
                } else if (document.body) {
                    scrollTop = document.body.scrollTop;
                }
                let  scrollHeight = document.body.scrollHeight || document.documentElement.scrollHeight
                let  clientHeight = document.documentElement.clientHeight || document.body.clientHeight
                console.log(scrollTop)
                if(window.screen.width < 768){
                    if(scrollHeight+clientHeight >= scrollTop){
                        if(this.DataStatus){
                            this.phonelistByCategory(this.xialaPage++,25,1)
                        }else {
                            // this.$message('已经没有数据了');
                        }
                    }
                }
            },
            phonelistByCategory(keyword,page){
                this.$http({
                    url:this.$Api.search,
                    params:{
                        keyword:value,
                        page:page,
                        pageSize:25
                    }
                }).then((res)=>{
                    console.log('搜索结果',res)

                    this.$http({
                        url:this.$Api.search,
                        params:{
                            keyword:value,
                            page:page,
                            pageSize:99999999
                        }
                    }).then((res)=>{
                        this.searchMax = res.data.length
                        // this.searchMax = 25 * res.count
                    })

                    this.searchMax = res.data.length

                    if(res.data.length > 0){
                        this.maxPage = res.count
                        this.vr_info.push(res.data)
                    }else{
                        this.DataStatus = false
                    }
                    console.log('s全部项目',res)
                })
            },
        }
    }
</script>

<style scoped>
    li {
        list-style: none;
        cursor: default;
    }
    .findInfo{
        padding-top: 15px;
        padding-bottom: 15px;
        width: 100%;
        border-bottom: 1px #d4d4d4 solid;
    }
    .content{
        max-width: 1180px;
        /*background-color: #b6b6b6;*/
        /*height: 100vh;*/
        margin: 0 auto;
    }

</style>